import { httpPost, httpGet } from '@/utils/request';

export const getUserInfo = () => httpPost('/api/sys/user/info', {});
export const Logout = () => httpGet('/api/logout', {});
